import { omit } from 'lodash';
import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { PackageInventoryQueryParams } from '../../../helpers/packageInventory';
import type { FetchVersionDetailsResponse } from '../../../../shared/organizationPackages/response';

// The server ignores pagination for this endpoint; drop it so paging the projects table doesn't refetch.
const omitPagination = (params: PackageInventoryQueryParams) => omit(params, ['page', 'count']);

const fetchPackageVersionMetadata = (
  locator: string,
  version: string,
  params: PackageInventoryQueryParams,
) => get<FetchVersionDetailsResponse>(
  `/api/packages/${nuc(locator)}/versions/${encodeURIComponent(version)}`,
  true,
  omitPagination(params),
  { encodeQuery: true },
);

export const getPackageVersionMetadataQueryKey = (
  locator: string,
  version: string,
  params: PackageInventoryQueryParams,
) => ['packages', locator, 'versions', version, 'metadata', omitPagination(params)] as const;

export default function usePackageVersionMetadata(
  locator: string,
  version: string,
  params: PackageInventoryQueryParams,
) {
  return useQuery<FetchVersionDetailsResponse>({
    queryKey: getPackageVersionMetadataQueryKey(locator, version, params),
    queryFn: () => fetchPackageVersionMetadata(locator, version, params),
    enabled: Boolean(locator && version),
    staleTime: 1000 * 60 * 5,
  });
}
